import styled from 'styled-components';
import { Trans } from '@lingui/react';

import {
    SectionContainer,
    ContentWrapper,
    tabletBreakpoint,
} from '~/styles/common';

const MissionVision = () => {
    return (
        <StorySectionContainer>
            <ContentWrapper>
                <Wrapper>
                    <Column>
                        <div>
                            <Heading>
                                <Trans id="global.about.missionVision.mission.heading" />
                            </Heading>
                            <Text>
                                <Trans id="global.about.missionVision.mission.description" />
                            </Text>
                        </div>
                        <div>
                            <Heading>
                                <Trans id="global.about.missionVision.vision.heading" />
                            </Heading>
                            <Text>
                                <Trans id="global.about.missionVision.vision.description" />
                            </Text>
                        </div>
                    </Column>
                    <Image src="/static/images/new_web/mision-vision.svg"></Image>
                </Wrapper>
            </ContentWrapper>
        </StorySectionContainer>
    );
};

const Heading = styled.div`
    font-weight: bold;
    font-size: 38px;
    line-height: 20px;
    color: #000000;
    margin-bottom: 20px;
    margin-top: 20px;

`;

const StorySectionContainer = styled(SectionContainer)`
    background: white;
`;
const Wrapper = styled.div`
    width: 100%;
    display: flex;

    @media (max-width: ${tabletBreakpoint}) {
        flex-direction: column;
        justify-content: center;
    }
`;

const Column = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-around;
`;

const Text = styled.div`
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 34px;
    color: #7b7b7b;

    @media (max-width: ${tabletBreakpoint}) {
        margin-bottom: 32px;
    }
`;



const Image = styled.img``;
export default MissionVision;
